module.exports = __webpack_public_path__ + "img/pet_salute.f48b6351.jpg";